
import proDesc from '../__customize__/pro_desc/pro_desc.vue';

export default {
  pro_desc: {
    component: proDesc,
    labelName: '测试'
  },
};
